<template>
  <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
  </div>
         <!-- Weekoff ui start -->
          <div class="flex py-2">
            <!-- Left Sidebar for Leave Request -->
            <div class="w-1/4  border-0">
              <!-- <div>
                <h5 class=" font-semibold ">Leave Request</h5>
                <p class="text-sm">Select date and add leave request</p>
              </div> -->
              <!-- Calendar (Using DevExtreme DxCalendar) -->
              <DxCalendar
                v-model="selectedDates"
                display-format="yyyy-MM-dd"
                multi-view="false"
                class="cal"
              />
              <!-- Buttons -->
             
              <!-- Leave Types Section -->
              <div class="mt-6">
                <h4 class="text-md font-semibold mb-1">Leaves Type</h4>
                <div class="space-y-2">
                  <div class="flex items-center text-sm">
                    <span class="w-3 h-3 rounded-full bg-blue-400 inline-block mr-2"></span>
                    Casual Leave 
                  </div>
                  <div class="flex items-center text-sm">
                    <span class="w-3 h-3 rounded-full bg-red-400 inline-block mr-2"></span>
                    Sick Leave 
                  </div>
                  <div class="flex items-center text-sm">
                    <span class="w-3 h-3 rounded-full bg-green-400 inline-block mr-2"></span>
                    Earned Leave 
                  </div>
                </div>
              </div>
              <!-- Other Status Section -->
              <div class="mt-4">
                <h4 class="text-md font-semibold mb-1">Other Status</h4>
                <div class="space-y-2">
                  <div class="flex items-center text-sm">
                    <span class="w-3 h-3 rounded-full bg-gray-600 inline-block mr-2"></span>
                    Loss of Pay
                  </div>
                  <div class="flex items-center text-sm">
                    <span class="w-3 h-3 rounded-full bg-red-200 inline-block mr-2"></span>
                    Holidays
                  </div>
                </div>
              </div>
            </div>

            <!-- Main Calendar Section -->
            <div class="w-3/4 ">
              <div class="flex justify-between items-center">
                <!-- Month Navigation -->

              <!-- Calendar Grid -->
              <DxScheduler
            time-zone="America/Los_Angeles"
            :current-date="currentDate"
            :views="views"
            :height="450"
            current-view="month"
              use-drop-down-view-switcher="false"
              />
            </div>
            </div>
            </div>
          <!-- weekoff ui end -->
 
  
</template>



<script>
import "devextreme/data/odata/store";
import DxCalendar from "devextreme-vue/calendar";
import DxScheduler, { DxSchedulerTypes } from 'devextreme-vue/scheduler';
import DxButton from "devextreme-vue/button";


// let collapsed = false;

export default {
name: "weekoff",
props: {
moduleRoute: String,
slug: String,
currentProduct: String,
headers: Array,
moduleName: String,
moduleLabel:String,

},
components: {
DxCalendar,
  DxButton,
  DxScheduler,
  DxSchedulerTypes
},
data() {
const today = new Date();
return {
views: ['month'],
currentDate: new Date(today.getFullYear(), today.getMonth(), 1),
cardData: [
  { id: 1, count: 8, label: 'understanding' },
  { id: 2, count: 12, label: 'analysis' },
  { id: 3, count: 15, label: 'research' },
  { id: 1, count: 8, label: 'understanding' },
  { id: 2, count: 12, label: 'analysis' },
],

};
},
methods: {
getDayStyle(day) {
return this.selectedDates.includes(day.date)
  ? 'bg-blue-200'
  : '';
},

sayHelloWorld() {
alert("Hello world!");
},
goToCreate() {
this.$inertia.get("/" + this.slug + "/" + this.moduleRoute + "/create");
//   this.$inertia.get( this.moduleRoute + '/create');
},
deleteMulti(){

this.$inertia.get(route( this.moduleRoute+".mutlidelete", [this.slug,this.selectedArr]));

},

},

mounted() {
// this.checkMobile();
// console.log("PRODC ID", this.prodId);
},
};
</script>

<style>
.grey-background-container {
background-color: #ffffff;
height: 100%;
}
p {
/* margin-top: 0; */
margin-bottom: 0.1rem;
}
h5{
margin-bottom: 0.1rem;
}
.dx-calendar {
width: 292px !important;
min-width: 292px !important;
height: 225.4px;
min-height: 225.4px;
background-color: #fff;
outline: 0;
border: 1px solid transparent;
}
.cal{
/* margin-top: 10px; */
/* box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px; */
}
h4{
font-size: 1.2rem;
}
.dx-scheduler-work-space-month .dx-scheduler-date-table {
width: 100%;
height: 100%;
}
</style>
